import { createTheme } from "@mui/material/styles";
import { ZebBaseTheme } from "zebbasictheming";
export const globalTheme = createTheme(ZebBaseTheme, {
    components: {
        MuiTypography: {
            styleOverrides: {
                h4: {
                    fontSize: "var(--default-font-size)",
                    color: "var(--clr-primary)"
                },
                subtitle1: {
                    fontSize: "var(--default-text-font-size)",
                    fontFamily: "BrownStd-Bold",
                    color: "var(--clr-secondary)",
                },
                body1: {
                    fontSize: "var(--default-text-font-size)",
                    fontFamily: "var(--default-font-family)",
                    color: "var(--clr-primary)",
                },
            },
        },
        MuiBreadcrumbs: {
            styleOverrides: {
                ol: {
                    height: "var(--side-menu-width)"
                }
            }
        }
    },
});
